module.exports = __webpack_public_path__ + "img/United States Minor Outlying Islands.0b237ab1.svg";